module.exports = __webpack_public_path__ + "solution-build/img/banner@2.526d3cf7.jpg";